<template>
  <v-container>
    <TitleParagraphRow :value="value" />

    <v-row>
      <v-col>
        <PromotedResourceList :value="data" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { contentProvider } from '#root/renderer/contentProvider'

defineProps({
  value: {
    required: true,
    type: Object
  }
})

const data = ref(null)

async function fetchData() {
  data.value = await contentProvider.findMany('promoted-resources', true)
}

onMounted(async () => {
  await fetchData()
})
</script>
